
import { useFormik } from 'formik'
import toast from 'react-hot-toast';
import { useHistory } from 'react-router';
import { CadastrarModel } from '../../../model/api/Cadastrar';
import { useSessaoAtual } from '../../../services/providers/sessao-atual-provider/sessao-atual-provider';
import Ellipse1 from '../../components/public/cadastrar/ellipse13534366-h1ms.svg'
import Ellipse2 from '../../components/public/cadastrar/ellipse13534367-x809.svg'
import { CircularLoading } from '../../components/utils/circular-loading';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import './autoComCadastrar.css'
import { Helmet } from 'react-helmet';
import { BaixasStorageKeys, useBaixasStorage } from '../../../services/use-cases/baixas-storage';
import { stringNumeros } from '../../../utils/string-numeros'
import { maskCnpjCpf, maskPhone } from '../../../utils/masks';

export function CadastrarPage() {
    const { Cadastrar, IrParaRota, carregando } = useSessaoAtual();
    const { getRegister, delRegister } = useBaixasStorage()
    const history = useHistory()
    const emailTelefone = getRegister(BaixasStorageKeys.emailTelefone)

    const formik = useFormik({
        initialValues: {
            email: (emailTelefone && emailTelefone.email) ? emailTelefone.email : '',
            telefone: (emailTelefone && emailTelefone.telefone) ? maskPhone(emailTelefone.telefone) :
             '',
            nome: '',
            nomeEmpresa: '',
            cpfcnpj: ''
        },
        onSubmit: values => {
            EfetuarCadastro({
                email: values.email,
                telefone: stringNumeros(values.telefone),
                nome: values.nome,
                nomeEmpresa: values.nomeEmpresa,
                cpfcnpj: stringNumeros(values.cpfcnpj),
                responsavelId: '',
                dataVisita: new Date()
            })
        }
    })

    const EfetuarCadastro = async (model: CadastrarModel) => {
        try {
            await Cadastrar(model)
            delRegister(BaixasStorageKeys.emailTelefone, false)
            history.push(IrParaRota())
        } catch (e: any) {
            toast.error(e.message)
        }
    }

    return (
        <div className='cadastrarPage'>
            <Helmet>
                <title>Cadastrar - Saurus AutoCom</title>
            </Helmet>
            <div className="p-d-v1430-container">
                <div className="p-d-v1430-p-d-v1430">
                    <div className="p-d-v1430-group11911453">
                        <img alt="Ellipse11455" src={Ellipse1} className="p-d-v1430-svg09" />
                        <img alt="Ellipse11454" src={Ellipse2} className="p-d-v1430-svg10" />
                    </div>
                </div>
            </div>
            <div className="container content-inicio">
                <button title="Voltar" onClick={() => history.push('/login')} className='btnVoltar'>
                    <ArrowBackIosIcon style={{ color: '#000' }} />
                </button>
                <div>
                    <div className="content-acessar">
                        <div style={{margin: '9px 0 10px 0'}}>
                            <span className="p-d-v1430-text03">Criar conta</span>
                        </div>
                        {carregando && <CircularLoading tipo='FULLSIZED' />}
                        <div className="row">
                            <div className="col-12">
                                <form id="form-cadastrar" onSubmit={formik.handleSubmit}>
                                    <div style={{margin: '0 0 20px 0'}}>
                                        <span className="form-realizar">Para realizar seu cadastro, preencha os campos abaixo:</span>
                                    </div>
                                    <div style={{margin: '0 0 20px 0'}}>
                                        <span className="form-label">Nome</span>
                                        <input {...formik.getFieldProps('nome')} autoComplete="off" placeholder="Nome completo" required name="nome" type="text" className="form-control" />
                                    </div>
                                    <div style={{margin: '0 0 20px 0'}}>
                                        <span className="form-label">Email</span>
                                        <input {...formik.getFieldProps('email')} autoComplete="off" inputMode='email' type="email" className="form-control" required={formik.values.telefone.length === 0} name="email" placeholder="@exemplo.com" />
                                    </div>
                                    <div style={{margin: '0 0 20px 0'}}>
                                        <span className="form-label">Telefone</span>
                                        <input {...formik.getFieldProps('telefone')}
                                            autoComplete="new-password"
                                            onChange={e => formik.setFieldValue('telefone', maskPhone(e.target.value))}
                                            required={formik.values.email.length === 0}
                                            inputMode="numeric"
                                            placeholder="Insira seu número"
                                            type="text"
                                            name="telefone"
                                            className="form-control" />
                                    </div>
                                    <div style={{margin: '0 0 20px 0'}}>
                                        <span className="form-label">CPF/CNPJ</span>
                                        <input {...formik.getFieldProps('cpfcnpj')} autoComplete="off" onChange={e => formik.setFieldValue('cpfcnpj',maskCnpjCpf(e.target.value))} inputMode='numeric' placeholder="(Opcional)" title="CPF/CNPJ" type="text" name="cpfcnpj" className="form-control" />
                                    </div>
                                    <div style={{margin: '0 0 20px 0'}}>
                                        <span className="form-label">Nome da Empresa</span>
                                        <input {...formik.getFieldProps('nomeEmpresa')} autoComplete="off" placeholder="(Opcional)" type="text" name="nomeEmpresa" className="form-control" />
                                    </div>
                                    <div className="d-grid gap-2 container-btn-continuar">
                                        <button id="btn" className="btn btn-acessar" type="submit">Continuar</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
